import { ChevronLeft, ChevronRight } from "lucide-react";

// Accessible numbered pagination. Renders nothing when only a single page.
export function ListingPagination({ page, totalPages, onChange, testid = "listing-pagination" }) {
  if (totalPages <= 1) return null;
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  const btn = "flex h-8 min-w-8 items-center justify-center rounded-full border px-3 font-accent text-xs transition-colors disabled:opacity-40 disabled:cursor-not-allowed";
  return (
    <nav className="mt-10 flex items-center justify-center gap-2" aria-label="Pagination" data-testid={testid}>
      <button className={`${btn} border-charcoal text-charcoal hover:bg-charcoal hover:text-white`} disabled={page <= 1} onClick={() => onChange(page - 1)} data-testid={`${testid}-prev`} aria-label="Previous page"><ChevronLeft className="h-4 w-4" /></button>
      {pages.map((p) => (
        <button key={p} onClick={() => onChange(p)} data-testid={`${testid}-page-${p}`} aria-current={p === page ? "page" : undefined}
          className={`${btn} ${p === page ? "border-saffron bg-saffron text-white" : "border-gold/40 text-charcoal hover:border-saffron"}`}>{p}</button>
      ))}
      <button className={`${btn} border-charcoal text-charcoal hover:bg-charcoal hover:text-white`} disabled={page >= totalPages} onClick={() => onChange(page + 1)} data-testid={`${testid}-next`} aria-label="Next page"><ChevronRight className="h-4 w-4" /></button>
    </nav>
  );
}
